// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j_LG5","col":"styles_col__bdP7h"};